module.exports = ".form-group .control-label{\n    text-align: left;\n    margin-bottom: 5px;\n}\n\n.remove-form{\n    padding: 20px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/agora/components/account-data/accounts/details/remove-credit-application/remove-credit-application.component.css
// module id = ./src/app/agora/components/account-data/accounts/details/remove-credit-application/remove-credit-application.component.css
// module chunks = main